import { WorkrateLevel } from '@/types';

export const getWorkrateLevel = (percent: number): WorkrateLevel => {
  if (percent >= 80) return 'green';
  if (percent >= 50) return 'orange';
  return 'red';
};

export const WORKRATE_COLORS: Record<WorkrateLevel, string> = {
  green: '#4CAF50',
  orange: '#FF9800',
  red: '#F44336',
};
